
import TestObj from "../TestObj";
import FBOM from "./FBOM";
import Hasher from "./Hasher";
import _ = require("lodash");

import FBSyncBase from "./FBSyncBase";
import RiotDB from "../RiotDB";
import GoogleSheetDB from "../GoogleSheetDB";
import {createSimPlayer, Calculation} from "../calculation/Calculation";
import KillPageStore from "../KillPageStore";

let clone = require("clone");
let diff = require('deep-diff').diff;

let jsonp = require('jsonp');


function jp(url:string){
	return new Promise((resolve, reject) => {
		jsonp(url,(err,data)=>{
			if(err) return reject(err);
			return resolve(data);
		});
	});

}


export function run(){


	return (async() => {

		await GoogleSheetDB.loadP();
		await RiotDB.loadP();
		let result = await RiotDB.loadChampionAbilityIconsP("Fiddlesticks");
		console.log(result);


		// let uniqueStats = {};
        //
		// _.forOwn(RiotDB.runesByName, (rune, key)=>{
		// 	_.forOwn(rune.stats, (value, key)=>{
		// 		if (key == "PercentHPPoolMod"){
		// 			console.log('name:', rune.name);
		// 		}
		// 		uniqueStats[key] = true;
		// 	})
		// });
        //
		// let output = '';
		// _.forOwn(uniqueStats,(value, key)=>{
		// 	output += `${key}:number;\n`;
		// });
		// console.log(output);


		// let talon = createSimPlayer(1,"Talon",
		// 	GoogleSheetDB.getChampionRunesForChampion("Talon")[0].runes,
		// 	GoogleSheetDB.getSkillOrdersForChampion("Talon")[0]
		// );
		// let lux = createSimPlayer(1,"Lux",
		// 	GoogleSheetDB.getChampionRunesForChampion("Lux")[0].runes,
		// 	GoogleSheetDB.getSkillOrdersForChampion("Lux")[0]);
        //
		// console.log(talon);
		// console.log(lux);
        //
		// talon.level = 3;
		// let ability = GoogleSheetDB.getChampionAbilities("Lux")[2];
		// console.log(ability);
		// console.log(talon.getRankForAbility("W"));
		// talon.level = 6;
		// console.log(talon.getRankForAbility("R"));
		// console.log(talon.getRankForAbility("E"));
		// console.log(talon.getRankForAbility("W"));
        //
		// lux.level = 8;
		// talon.level = 8;
		// console.log(Calculation.calculateRawAbilityDamage(lux,ability));
		// console.log(Calculation.calculateAbilityDamageDone(lux,talon,ability));



		//
		// let id = "||HyRHnrrpe";
		//
		// FBOM.addObjectToLoad(id);
		// FBOM.loadObjectsP();
		// await FBOM.waitForObjectsToLoadP();
		// let test:TestObj = (FBOM.getObject(id) as TestObj);
		// console.log(test);
		// console.log(clone(test));
		//
		// let json:any = Object.assign({},test);
		// json.blah = "k";
		//
		// console.log(diff(clone(test),json));


	})();


}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/framework/testing.ts